import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getContactUs, removeContactUs } from '../slice/contactUsSlice';
import AdminTable from 'common/AdminTable';
import TruncatedMessage from 'common/TruncatedMessage'
const Contactus = () => {
    const dispatch = useDispatch();
    const cartData = useSelector((state) => state.contactus);
    
    const tableHeaders = [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: 'Name',
            accessor: 'name',
        },
        {
            Header: 'Email',
            accessor: 'email',
        },
        {
            Header: 'Subject',
            accessor: 'subject',
        },
        {
            Header: 'Mobile',
            accessor: 'mobile',
        },
        {
            Header: 'Message',
            accessor: 'message',
            Cell: ({ row }) => <TruncatedMessage text={row.original.message} maxLength={10} />
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
              
                <button
                    className="btn removebtn"
                    onClick={() => dispatch(removeContactUs(row.original.id))}
                >
                    Remove
                </button>
            ),
        },
    ];
    useEffect(() => {
        dispatch(getContactUs());
    }, [dispatch]);

    return (
        <>
            <div className="container-fluid mt-4">
                {/* Premium Animated Header Banner */}
                <div 
                    className="dashboard-header-card d-flex align-items-center justify-content-between mb-4 mx-2 shadow-lg" 
                    style={{ 
                        background: 'linear-gradient(135deg, #0d47a1 0%, #00695c 100%)', 
                        padding: '1.5rem 2rem', 
                        borderRadius: '15px',
                        animation: 'fadeInUp 0.6s ease-out forwards'
                    }}
                >
                    <div className="d-flex align-items-center">
                        <div className="icon-circle mr-3" style={{ background: 'rgba(255,255,255,0.2)', width: '50px', height: '50px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <i className="fa fa-envelope text-white" style={{ fontSize: '24px' }}></i>
                        </div>
                        <div>
                            <h3 className="text-white font-weight-bold mb-0" style={{ letterSpacing: '0.5px' }}>Enquiries & Contacts</h3>
                            <p className="text-white-50 mb-0 small">Review and manage messages from visitors</p>
                        </div>
                    </div>
                </div>
                {/* Conditionally render AdminTable */}
                {cartData?.data?.length > 0 && (
                    <AdminTable tableHeaders={tableHeaders} tableData={cartData.data} />
                )}
            </div>
        </>
    );
};

export default Contactus;
